import React from "react";
import styles from "./FallbackGradient.module.scss";
function FallbackGradient() {
  return (
    <svg
      width="1340"
      height="900"
      viewBox="0 0 1340 900"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={styles.shadowSvg}
    >
      <g opacity="0.3" filter="url(#filter0_f_551_420)">
        <ellipse
          cx="670.5"
          cy="78"
          rx="470.5"
          ry="451"
          fill="#0128CC"
          fillOpacity="0.6"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_551_420"
          x="0"
          y="-573"
          width="1341"
          height="1302"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="100"
            result="effect1_foregroundBlur_551_420"
          />
        </filter>
      </defs>
    </svg>
  );
  return (
    <svg
      className="grid-background"
      viewBox="0 0 1512 1510"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M0.500105 0L0.500039 1512M101.3 0L101.3 1512M202.1 0L202.1 1512M302.9 0L302.9 1512M403.7 0L403.7 1512M504.5 0L504.5 1512M605.3 0L605.3 1512M706.1 0L706.1 1512M806.9 0L806.9 1512M907.7 0L907.7 1512M1008.5 0L1008.5 1512M1109.3 0L1109.3 1512M1210.1 0L1210.1 1512M1310.9 0L1310.9 1512M1411.7 0L1411.7 1512M1512.5 0L1512.5 1512M1512 0.500039L6.60916e-05 0.499907M1512 101.301L9.57867e-05 101.301M1512 202.1L5.72794e-05 202.1M1512 302.9L5.28733e-05 302.9M1512 403.701L9.59637e-05 403.701M1512 504.5L4.40611e-05 504.5M1512 605.301L9.60817e-05 605.301M1512 706.1L9.61407e-05 706.099M1512 806.9L9.61997e-05 806.9M1512 907.701L9.62587e-05 907.701M1512 1008.5L2.20305e-05 1008.5M1512 1109.3L9.63768e-05 1109.3M1512 1210.1L9.64358e-05 1210.1M1512 1310.9L9.64948e-05 1310.9M1512 1411.7L9.65538e-05 1411.7M1512 1512.5L0 1512.5"
        stroke="url(#paint0_radial_551_421)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_551_421"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(756.25) rotate(90) scale(671.5 671.5)"
        >
          <stop stopColor="#0128CC" />
          <stop offset="1" stopColor="white" />
        </radialGradient>
      </defs>
    </svg>
  );
}

export default FallbackGradient;
